import m, {Vnode} from "mithril";
import {ComboItem} from "../../../../model/items/combo";
import {elementId} from "../../../../ui/items/helpers";
import _ from "underscore";
import {inputTextItemView} from "../../../../ui/items/inputText";

export default class ComboCell {

    private touched = false;

    constructor(
        public readonly comboItem: ComboItem
    ) { }

    public view(): Vnode|null {

        if (!this.comboItem.cell.visible) {
            return null;
        }

        const error = this.touched ? this.comboItem.validate() : undefined;
        const errorMessage = error?.messages.length ? error.messages[0] : "";

        const cssClass = 'comboCell' + (errorMessage ? ' invalid' : '') + (this.comboItem.cell.cssClass ? (' '+this.comboItem.cell.cssClass) : '');

        return m("div", {
            "class": cssClass
        }, [
            this.viewSelect(),
            this.comboItem.cell.hasInputText() ? inputTextItemView(this.comboItem.cell.getInputText()!) : null,
            (errorMessage) ? m('.validationBox', {}, m.trust(this.comboItem.form.questionary.renderText(errorMessage)) ) : null,
        ]);
    }

    private viewSelect(): Vnode {
        const options = this.comboItem.getOptions();

        // null or undefined are empty values => show prompt
        const currentValue: string = (this.comboItem.getVariable() === undefined || this.comboItem.getVariable() === null) ? '' : ''+this.comboItem.getVariable();

        return m('select', {
                value: currentValue,
                disabled: !this.comboItem.cell.enabled,
                style: {
                    id: elementId(this.comboItem, this.comboItem.cell.id),
                },
                onchange: m.withAttr("value", this.comboItem.set.bind(this.comboItem))
            }, _.map(options, (o) => {
                const optionValue: string = (o.value === undefined || o.value === null) ? '' : ''+o.value;
                return m('option', {
                    value: optionValue,
                    selected: currentValue === optionValue ? 'selected' : null
                }, this.comboItem.questionary.renderText(o.name))
            })
        );
}


}